export default "/images/minus-square.svg?8d669f15adb02523d6793d09e3992072";